export interface SessionExpiredEvent {
  event: 'session-expired'
}

export function SessionExpiredEvent(): SessionExpiredEvent {
  return { event: 'session-expired' }
}

export interface AuthenticatedEvent {
  event: 'authenticated'
}

export function AuthenticatedEvent(): AuthenticatedEvent {
  return { event: 'authenticated' }
}

export interface ExitAction {
  action: 'exit'
}

export function ExitAction(): ExitAction {
  return { action: 'exit' }
}

export interface AddToCalendarAction {
  action: 'add-to-calendar'
  icsDataUrl: string
}

export function AddToCalendarAction(icsDataUrl: string): AddToCalendarAction {
  return { action: 'add-to-calendar', icsDataUrl }
}

export interface DownloadDocumentAction {
  action: 'download-document'
  downloadUrl: string
}

export function DownloadDocumentAction(
  downloadUrl: string,
): DownloadDocumentAction {
  return { action: 'download-document', downloadUrl }
}

export interface OpenExternalUrlAction {
  action: 'open-external-url'
  url: string
}

export function OpenExternalUrlAction(url: string): OpenExternalUrlAction {
  return { action: 'open-external-url', url }
}
